import { useYear } from '../contexts/YearContext'

/**
 * Hook to get the latest SVV data date as YYYY-MM-DD string, capped at today.
 * Reads from YearContext (single data-freshness fetch shared across all consumers).
 */
export function useMaxDataDate(): string | null {
  const { maxDataDateStr } = useYear()
  return maxDataDateStr
}

/**
 * Hook to get the latest BrregLoan data date as YYYY-MM-DD string, capped at today.
 * Reads from YearContext (single data-freshness fetch shared across all consumers).
 */
export function useMaxLoanDate(): string | null {
  const { maxLoanDateStr } = useYear()
  return maxLoanDateStr
}
